import _ from 'underscore'
import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import SelectField from 'material-ui/SelectField'
import MenuItem from 'material-ui/MenuItem'
import {List, ListItem,MakeSelectable} from 'material-ui/List'
import ActionDone from 'material-ui/svg-icons/action/done'
import RaisedButton from 'material-ui/RaisedButton'

import spacing from 'material-ui/styles/spacing'
import Dropzone from 'react-dropzone'

import {setConfig,uploadTopo,saveTopo} from '../actions'
import locale from '../locale'
import {Areas,AreaRegions} from '../config'
import {routeSorting} from '../utils'
import {MarkerList} from '../config'
import {processBolt} from '../utils/bolt'
import SphereTopo from '../components/SphereTopo'

const SelectableList = MakeSelectable(List)


const MarkerSize = 16
const MarkerImage = {
  'Green':'images/green.svg',
  'Yellow':'images/yellow.svg',
  'Red':'images/red.svg',
  'Black':'images/black.svg',
}



class SpherePage extends Component {
  static contextTypes = {
    store: PropTypes.object.isRequired,
  }
  state = {topo:this.props.topoList[0],topoIndex:0}

  componentWillMount() {
    this.context.store.dispatch(setConfig('title',null))
  }

  componentDidMount(){
    // this.handleRouteChange(null,9,'367')
  }

  componentWillReceiveProps({topoList}){
    let topo = topoList[this.state.topoIndex]
    if(this.state.topo !==topo)
      this.setState({topo})
  }

  addMarker(e){
    let {longitude,latitude}= e

    let {topo,index,routeId,boltList,route} = this.state
    let boltKey = boltList ? boltList[index] : null

    if(!boltKey||!routeId)
      return
    topo = {...topo}

    let markers = {...(topo.markers||{})}
    markers[routeId] = {...markers[routeId]}
    markers[routeId][boltKey] = [longitude,latitude]
    topo.markers = markers

    boltKey = boltList[index + 1]
    if(boltKey && !markers[routeId][boltKey]){
      index = index +1
    }

    this.setState({topo,index})

  }

  addLineNode(e){
    let {texture_x:x,texture_y:y}= e

    let {topo,routeId} = this.state
    if(!routeId)
      return


    topo = {...topo}
    topo.lines = {...(topo.lines||{})}
    topo.lines[routeId] = topo.lines[routeId] ? [...topo.lines[routeId]] : []
    topo.lines[routeId].push([x,y])

    // console.log('addLineNode',topo)

    this.setState({topo})
  }

  addLink(e){
    let {texture_x:x,texture_y:y}= e

    let {topoList} = this.props
    let {topo,linkToTopo:index} = this.state
    let {id} = topoList[index] || {}
    if(!id)
      return

    topo = {...topo}
    topo.links = {...(topo.links||{})}
    topo.links[id] = {x,y}
    this.setState({topo})
  }

  onClick= (e) => {
    if(this.state.linkToTopo!==null){
      this.addLink(e)
    } else {
      this.addLineNode(e)
    }
  }

  onDrop = (files) =>{
    let {newTopo:topo} = this.props
    topo.file = files[0]
    this.props.dispatch(uploadTopo(topo))
    this.setState({addmore:false})
  }

  handleSelectChange = (event, index, value)=>{

    if(value.includes('topo')){
      let topoIndex = value.split(':')[1]
      console.log('linkToTopo',topoIndex)
      this.setState({linkToTopo:topoIndex,routeId:value})
      return
    }

    let {routeList} = this.props
    let route = routeList[index]
    let {bolts} = route
    let boltList = bolts ? MarkerList
                          .filter(key=>!!bolts[key]&&bolts[key]!=='S_PRE'&&bolts[key]!=='S_NEXT') : null
    this.setState({linkToTopo: null,routeId:value,index:0,route,boltList})
  }

  handleTopoChange = (event, index, routeId)=>{
    let {topoList} = this.props
    this.setState({topoIndex:index,topo:topoList[index]})
  }



  handleChangeList = (event, index) => {
    this.setState({index})
  }

  renderBolt(){
    let {routeId,boltList,topo:{markers={}},index} = this.state
    if(!routeId ||!boltList)
      return
    markers = markers[routeId] || {}
    return (
      <SelectableList
      value={index}
      onChange={this.handleChangeList}>
      {boltList.map((key,index)=><ListItem
        value={index}
        key={key}
        rightIcon={markers[key] && <ActionDone />}
        primaryText={key}/>)}
      </SelectableList>
      )
  }
  saveTopo = ()=>{
    let{longitude,latitude} = this.refs.sphere.getPosition()
    let zoom = this.refs.sphere.getZoomLevel()

    let {topo} = this.state
    topo = {...topo,longitude,latitude,zoom}

    // topo.region = '鯨魚頭'
    // delete topo.id
    // delete topo.lines
    // delete topo.markers
    // console.log('saveTopo',topo)
    // topo.url = 'https://firebasestorage.googleapis.com/v0/b/project-2803619783974357321.appspot.com/o/topos%2F1464624848517?alt=media&token=467f2f58-9747-420d-a59a-cb7f72e41b3f'
    this.props.dispatch(saveTopo(topo))
  }

  renderDropzone(){
    let {desktopKeylineIncrement} = spacing
    const style = {
      paddingTop: spacing.desktopKeylineIncrement,
    }

    let styleDropzone = {
      display:'flex',
      margin:32,
      borderWidth:5,
      borderStyle:'dashed',
      borderRadius:5,
      borderColor:'#E0E0E0',
      justifyContent:'center',
      alignItems:'center',
      textAlign:'center',
      width:window.innerWidth-64,
      height:window.innerHeight-desktopKeylineIncrement-64,
    }
    let {newTopo:{area,region}}= this.props
    let caption = `${locale.get(area)} · ${locale.get(region)}`

    return (
      <div style={style}>
        <Dropzone style={styleDropzone} onDrop={this.onDrop}>
        <div>{caption}<br/>{locale.R.DropSpherePhoto}</div>
        </Dropzone>
      </div>
      )

  }

  removeMarker = ()=>{
    let {routeId,index,boltList,topo} = this.state
    let boltKey = boltList[index]
    topo = {...topo}
    let markers = {...topo.markers}
    markers[routeId] = {...markers[routeId]}
    delete markers[routeId][boltKey]
    topo.markers = markers

    this.setState({topo})
  }

  undo = ()=>{
    let {routeId,topo} = this.state
    if(topo.lines[routeId] &&topo.lines[routeId].length){
      topo = {...topo}
      topo.lines = {...topo.lines}
      topo.lines[routeId] = [...topo.lines[routeId]]
      topo.lines[routeId].pop()
      this.setState({topo})
    }
  }
  addMore =()=>{
      this.setState({addmore:true})
  }

  renderTopos(){
    let {desktopKeylineIncrement} = spacing
    let subNavWidth = desktopKeylineIncrement * 3;
    let styles = {
      button:{
        // padding:8,
        // width: subNavWidth-16,
        margin:8,
        width: subNavWidth-16,
      },

    }
    let styleBottom = {
      position:'absolute',
      bottom: 8,
    }

    let {topoList} = this.props
    let {topoIndex} = this.state

    return (
      <div style={styleBottom}>
          <SelectField
          style={styles.button}
          floatingLabelText="Topo"
          value={topoIndex}
          onChange={this.handleTopoChange}>
          {topoList.map((topo,index)=><MenuItem
            key={index}
            value={index}
            primaryText={'Topo '+(index+1)}/>)}
          </SelectField>

          <div>
          <RaisedButton
          style={styles.button}
          onTouchTap={this.addMore}
          label="新增其他照片"
          primary={true}/>
          </div>
      </div>
    )
  }

  renderActions() {
    let {desktopKeylineIncrement} = spacing
    let subNavWidth = desktopKeylineIncrement * 3;
    let style = {
      margin:8,
      width: subNavWidth-16,
    }
    let {topo} = this.state
    let {routeId,topo:{markers={}},index,boltList} = this.state
    let isMarked = routeId && boltList && markers[routeId] &&markers[routeId][boltList[index]]
    let isEqual = false// _.isEqual(markers,topo.markers)

        // <RaisedButton
        // style={style}
        // onTouchTap={this.removeMarker}
        // label="清除標示"
        // secondary={true}
        // disabled={!isMarked}/>

    return (
      <div>

        <RaisedButton
        style={style}
        onTouchTap={this.undo}
        label="Undo"
        secondary={true}/>

        <RaisedButton
        style={style}
        onTouchTap={this.saveTopo}
        label="上傳"
        primary={true}
        disabled={isEqual}/>

      </div>

      )

  }
  render() {
    let {desktopKeylineIncrement} = spacing
    let subNavWidth = desktopKeylineIncrement * 3;

    const styles = {
      root:{
        paddingTop: desktopKeylineIncrement,
        display:'flex',
        flexDirection:'row',
      },
      content: {
        height:window.innerHeight-desktopKeylineIncrement,
        width:window.innerWidth-subNavWidth,

      },
      sphere:{
        height:window.innerHeight-desktopKeylineIncrement,
        width:window.innerWidth-subNavWidth,
      },

      secondaryNav: {
        width: subNavWidth,
        height:window.innerHeight-desktopKeylineIncrement,
        overflow:'auto',
      },
      select:{
        padding:8,
        marginTop:16,
        width: subNavWidth-16,
      },
    }

    let {topoList,routeList,routes} = this.props
    let {topoIndex,addmore,topo} = this.state
    let {routeId} = this.state
    if(!topo||!topo.url||addmore) {
      return this.renderDropzone()
    }
    // {this.renderBolt()}

    let topoSelectList = topoList.map((topo,index)=>index)
                                  .filter(index=>index!==topoIndex)

    return (
      <div style={styles.root}>
        <div style={styles.secondaryNav}>
          <SelectField
          style={styles.select}
          floatingLabelText={locale.R.Route}
          value={routeId}
          onChange={this.handleSelectChange}>
          {routeList.map(route=><MenuItem
            key={route.id}
            value={route.id}
            primaryText={route.id + ' '+route.name}/>)}
          {topoSelectList.map(index=><MenuItem
            key={'topo'+index}
            value={'topo:'+index}
            primaryText={'Link to Topo'+(index+1)}/>)}
          </SelectField>
          {this.renderActions()}
          {this.renderTopos()}
        </div>
        <div style={styles.content}>
          <SphereTopo
          ref='sphere'
          onClick={this.onClick}
          style={styles.sphere}
          routes={routes}
          topo={topo}/>
        </div>
      </div>

      )
  }
}

function mapStateToProps(state,props) {
  let { routes,comments,tags,me:{fbid,uid,name},topos} = state
  let {regionId} = props.params

  let index = regionId.split('-')
  let area = Areas[index[0]]
  let region = AreaRegions[area][index[1]]
  let routeList = Object.keys(routes)
  .map(id=>routes[id])
  .filter(route=>( route.region===region &&
    route.area === area &&
    // route.bolts&&
    (!route.style.includes('多繩距')||route.id.includes('P'))))
  .sort(routeSorting)

  let topoList = Object.keys(topos).map(id=>topos[id])
  .filter(topo=>(topo.area===area&&topo.region===region))
  .sort((a,b)=>{
    return Object.keys(a.lines||{})[0] > Object.keys(b.lines||{})[0]
  })

  let newTopo = {area,region,fbid,uid,name}


  return {
    newTopo,
    routes,
    topoList,
    routeList,
  }
}

export default connect(mapStateToProps)(SpherePage)



/** WEBPACK FOOTER **
 ** ./src/app/containers/SpherePage.js
 **/